import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { hotArticles, categories } from '@/mocks/siteData';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const displayName = category?.name || '分类';
  const categoryArticles = hotArticles.filter((a) => {
    const cat = categories.find((c) => c.slug === slug);
    return cat ? a.category === cat.name : false;
  });
  const displayArticles = categoryArticles.length > 0 ? categoryArticles : hotArticles;

  return (
    <>
      <Navbar />
      <main className="pt-20 pb-12 px-4 md:px-8 min-h-screen bg-background-50">
        <div className="max-w-7xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-8" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-foreground-700 transition-colors cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-600">{displayName}</span>
          </nav>

          <header className="mb-10">
            <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              {displayName}
            </h1>
            {category && (
              <p className="text-foreground-500 text-sm md:text-base max-w-2xl">
                {category.description} — 共 {category.count.toLocaleString()} 条爆料
              </p>
            )}
          </header>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {displayArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer border border-background-200/50 hover:border-background-300/60 transition-all duration-200"
              >
                <div className="relative h-48 md:h-52 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/50 via-transparent to-transparent"></div>
                  {article.badge && (
                    <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full text-[11px] font-semibold bg-primary-500 text-background-50">
                      {article.badge}
                    </span>
                  )}
                </div>
                <div className="p-5">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium">
                      {article.category}
                    </span>
                    <span className="text-foreground-400 text-xs">{article.date}</span>
                  </div>
                  <h2 className="font-heading font-bold text-foreground-950 text-base md:text-lg leading-snug mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                    {article.title}
                  </h2>
                  <p className="text-foreground-500 text-sm line-clamp-2 mb-4">{article.excerpt}</p>
                  <div className="flex items-center gap-4 text-foreground-400 text-xs">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {article.views > 10000 ? `${(article.views / 10000).toFixed(1)}万` : article.views}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-1-line"></i>
                      {article.comments}
                    </span>
                    <span>{article.author}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {displayArticles.length === 0 && (
            <div className="text-center py-20">
              <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100">
                <i className="ri-inbox-line text-3xl text-foreground-300"></i>
              </div>
              <p className="text-foreground-500 text-lg">该分类暂无爆料内容</p>
              <Link to="/" className="inline-block mt-4 text-primary-600 hover:text-primary-700 text-sm font-medium cursor-pointer">
                ← 返回首页
              </Link>
            </div>
          )}

          <div className="mt-10 pt-8 border-t border-background-200/70">
            <h3 className="font-heading font-bold text-foreground-950 text-lg mb-5">浏览其他分类</h3>
            <div className="flex flex-wrap gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                    cat.slug === slug
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-800'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": `${displayName} - 91吃瓜社区`,
            "description": category?.description || "浏览分类爆料内容",
            "url": `https://91chigua.com/category/${slug}`,
            "breadcrumb": {
              "@type": "BreadcrumbList",
              "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://91chigua.com" },
                { "@type": "ListItem", "position": 2, "name": displayName }
              ]
            }
          })}
        </script>
      </main>
      <Footer />
    </>
  );
}